import React from 'react';
import web_development from "../assets/web_developer.png";
import python from "../assets/python.png";
import ai_development from "../assets/ai_development.png";
import tool from "../assets/tool.jpg";
import tech from "../assets/tech.jpg";
import hacking from "../assets/hacking.png";

export const Skills = () => {

  return (
    <section class="skills">
      <div class="sec_header">
        <h2 class="sec_head">My Skills</h2>
      </div>
      <div class="skillset">
        <div class="skill">
          <img class="skill-icon" src={web_development} alt="Web Development Icon"/>
          <h3>Web Development</h3>
          <p>HTML, CSS, JavaScript, React</p>
        </div>
        <div class="skill">
          <img class="skill-icon" src={python} alt="Programming Languages Icon"/>
          <h3>Programming Languages</h3>
          <p>Python, C++, Java</p>
        </div>
        <div class="skill">
          <img class="skill-icon" src={ai_development} alt="Data Science Icon"/>
          <h3>Data Science</h3>
          <p>Machine Learning, Data Analysis</p>
        </div>
        <div class="skill">
          <img class="skill-icon" src={tool} alt="Tools & Technologies Icon"/>
          <h3>Tools & Technologies</h3>
          <p>Git, Docker, AWS</p>
        </div>
        <div class="skill">
          <img class="skill-icon" src={tech} alt="Web Development Icon"/>
          <h3>UI/UX Designer</h3>
          <p>Bootstrap, Canva, Wordpress</p>
        </div>
        <div class="skill">
          <img class="skill-icon" src={hacking} alt="Programming Languages Icon"/>
          <h3>Cyber Security</h3>
          <p>Networking, Bug Bounty, Penetration Testing</p>
        </div>
        <div class="skill">
          <img class="skill-icon" src={ai_development} alt="Data Science Icon"/>
          <h3>AI Engineer</h3>
          <p>AI Models, Deep Learning, Neural Networks</p>
        </div>
        <div class="skill">
          <img class="skill-icon" src={hacking} alt="Tools & Technologies Icon"/>
          <h3>Graphic Designer</h3>
          <p>Canva, Corel Draw</p>
        </div>
      </div>
    </section>
  );
};